module.exports = __webpack_public_path__ + "img/45.74e34969.jpg";